<script setup>
import { computed } from 'vue';


const props = defineProps({
    notifica: {
        type: Object,
        required: true,
    },
});

const animazione = computed(() => {

    let secondi = parseInt(props.notifica.timeout) / 1000;

    let animazione = `animation: ${secondi}s linear theme-color, ${secondi}s ease enter forwards; height: 4px;`;

    animazione += 'position: absolute; bottom: 0; left: 0; width: 100%; background-color: rgba(255, 255, 255, 0.5)';
    return animazione
});


</script>



<template>
        <v-alert :color="props.notifica.color" :icon="props.notifica.icon" :text="props.notifica.message" density="compact"
            border="start" :class="'elevation-2 '+props.notifica.customClass" >
            <div :style="animazione"></div>
            <template v-slot:append>
                <v-btn size="30" variant="plain" icon="mdi-close" @click="props.notifica.close()">
                </v-btn>
            </template>
        </v-alert>
</template>


<style lang="scss">
.progress-bar {
    @apply bg-gray-300;
    transform-origin: right;

    &.progress-bar-blue {
        @apply bg-gradient-to-r from-blue-600 to-blue-300;
    }

    &.progress-bar-green {
        @apply bg-gradient-to-r from-green-600 to-green-300;
    }

    &.progress-bar-yellow {
        @apply bg-gradient-to-r from-yellow-600 to-yellow-300;
    }

    &.progress-bar-red {
        @apply bg-gradient-to-r from-red-500 to-red-300;
    }
}

@keyframes theme-color {
    100% {
        background-position: 0%;
    }

    0% {
        background-position: 100%;
    }
}

@keyframes enter {
    100% {
        transform: scaleX(0);
    }

    0% {
        transform: scaleX(1);
    }
}
</style>
